<template>
  <div>
    <div class="row mt-4">
      <div class="col-md-8">
        <input class="input form-control"
               @keypress.enter="find()"
               v-model="query.generic"
               placeholder="Pesquisar por nome ou apelido">
        <search-icon @click="find()" class="icon icon-within"/>
      </div>
    
      <button class="col-md-1 ml-2 btn-sm btn-outline"
              :class="{ 'btn-outline-active': showFilter }"
              @click="showFilter = !showFilter">
        Filtros
        <chevron-down-icon class="fa-angle-right" :class="{'rotate-90': showFilter }"/>
      </button>
    
      <button v-if="changeQuery" @click="find()" class="btn btn-link">
        Aplicar filtros ({{ numberOfBadges }})
      </button>
    </div>
  
    <div class="row">
      <div class="col-md-12">
        <BadgeFilters :query="query" @clearBadge="find()" @clearAllBadges="find()"
                      :amount-changed="updateNumberOfBadges"
                      :filters="[filterStartDate, filterEndDate, filterType]"/>
      </div>
    </div>
  
    <template v-if="showFilter">
      <div class="row mt-4">
      </div>
    
      <div class="row mt-4">
        <div class="col-md-3">
          <label for="start-date">Data inicial</label>
          <input v-model="query.startDate" type="date" id="start-date" class="form-control">
        </div>
      
        <div class="col-md-3">
          <label for="end-date">Data final</label>
          <input v-model="query.endDate" type="date" id="end-date" class="form-control">
        </div>
      
        <div class="col-md-3">
          <label>Tipo de Evento</label>
          <Select2 :options="filterType" v-model="query.type" disabled="true"/>
        </div>
        
        <div class="col-md-3">
          <label for="nsu-manager-order-by">Ordenar por</label>
          <select v-model="orderBy" id="nsu-manager-order-by" class="form-control">
            <option value="updatedAt">Atualizado em</option>
            <option value="createdAt">Criado em</option>
            <option value="rank">Rank</option>
            <option value="rank2">Rank descendente</option>
          </select>
        </div>
      </div>
    </template>
    <hr>
  
    <div class="row">
      <div class="col-sm-12">
      
        <div class="row mt-4">
          <div class="col-md-12">
            <strong>
              {{infoTotalModels}}
            </strong>
          </div>
        </div>
      
        <table class="table table-borderless table-align table-h51">
          <thead>
            <tr>
              <th>ID</th>
              <th>Nome</th>
              <th>Apelido</th>
              <th>Tipo</th>
              <th>Rank</th>
              <th>Criado em</th>
              <th>Atualizado em</th>
              <th>Detalhes</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="counter in counters" :key="counter.id">
              <td>{{ counter.id }}</td>
              <td>{{ counter.name }}</td>
              <td>{{ counter.nickname }}</td>
              <td>{{ counter.counterType }}</td>
              <td>{{ counter.rank | percent }}</td>
              <td>{{ counter.createdAt | datetime }}</td>
              <td>{{ counter.updatedAt | datetime }}</td>
              <td>
                <small v-for="([key, value]) in Object.entries(counter.payload)" :key="key">
                  {{ key }}: <strong>{{ value }}</strong><br>
                </small>
              </td>
            </tr>
          </tbody>
        </table>
      
        <div class="row">
          <div class="col-md-12 my-1">
            <Pagination
              v-model="meta.currentPage"
              :total-count="meta.totalCount"
              :total-pages="meta.totalPages"
              @pagination="pagination"
            />
          </div>
        </div>
    
      </div>
    </div>
  </div>
</template>

<script>
  import BadgeFilters from '@/components/shares/BadgeFilters'
  import Pagination from '@/components/shares/specialTag/Pagination'
  import ModelMapper from '@/mixins/ModelMapper'
  import Select2 from '@/components/shares/Select2'
  import { ChevronDownIcon, SearchIcon } from 'vue-feather-icons'
  import { Filter } from '@/models/filter'
  
  export default {
    components: {
      BadgeFilters,
      ChevronDownIcon,
      Pagination,
      SearchIcon,
      Select2,
    },
    computed: {
      counters() {
        return this.getModels || []
      }
    },
    created() {
      this.buildFilter()
    
      const date = new Date()
      date.setDate(date.getDate())
      this.$set(this.query, 'startDate', date.toISOString().substring(0, 10))
    
      this.$set(this.query, 'periodType', 'updated_at')
      this.addOrderBy('updatedAt')
    
      this.defaultModelSetting.updateQueryURL = true
      this.asyncTemplateSelect({
        byURL: true,
        pagination: true
      })
    },
    data: () => ({
      filterEndDate: new Filter({
        key: 'endDate',
        label: 'Data final',
        type: 'date'
      }),
      filterStartDate: new Filter({
        key: 'startDate',
        label: 'Data inicial',
        type: 'date'
      }),
      filterType: new Filter({
        key: 'type',
        label: 'Tipo',
        table: [
          ['CityHallMapper', 'city_hall_mapper']
        ]
      }),
      modelPathPrefix: 'admin',
      nameModel: 'Counter',
      orderBy: 'updatedAt',
    }),
    filters: {
      percent(value) {
        return `${(value * 100).toFixed(2)} %`
      }
    },
    methods: {
      buildFilter() {
      
      },
      find() {
        this.asyncTemplateSelect()
      }
    },
    mixins: [ModelMapper],
    name: 'Index',
    watch: {
      orderBy(value) {
        this.order = []
        if (value === 'rank') {
          this.addOrderBy('rank')
          this.addOrderBy('updatedAt')
        } else if (value === 'rank2') {
          this.addOrderBy('rank', 'asc')
          this.addOrderBy('updatedAt', 'asc')
        } else {
          this.addOrderBy(value)
        }
      }
    }
  }
</script>

<style scoped>

</style>